import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Shell from "@/components/Shell";
import Dashboard from "@/pages/Dashboard";
import Fuel from "@/pages/Fuel";
import Cash from "@/pages/Cash";
import Compliance from "@/pages/Compliance";
import Maintenance from "@/pages/Maintenance";
import PL from "@/pages/PL";
import Settings from "@/pages/Settings";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import { StationProvider } from "@/lib/station";
import { AuthProvider, useAuth } from "@/lib/auth";

function AppShell() {
  const { user, initialized } = useAuth();
  if (!initialized) {
    return (
      <div className="min-h-screen bg-[#0F1115] text-gray-500 grid place-items-center">
        <div className="text-sm uppercase tracking-[0.2em]">Loading…</div>
      </div>
    );
  }
  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/" replace /> : <Login />} />
      <Route path="/register" element={user ? <Navigate to="/" replace /> : <Register />} />
      <Route
        path="/*"
        element={
          user ? (
            <StationProvider>
              <Shell>
                <Routes>
                  <Route path="/" element={<Dashboard />} />
                  <Route path="/fuel" element={<Fuel />} />
                  <Route path="/cash" element={<Cash />} />
                  <Route path="/compliance" element={<Compliance />} />
                  <Route path="/maintenance" element={<Maintenance />} />
                  <Route path="/pl" element={<PL />} />
                  <Route path="/settings" element={<Settings />} />
                </Routes>
              </Shell>
            </StationProvider>
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppShell />
        <Toaster
          theme="dark"
          position="top-center"
          toastOptions={{
            style: {
              background: "#1A1D24",
              border: "1px solid rgba(255,255,255,0.08)",
              color: "#F9FAFB",
            },
          }}
        />
      </AuthProvider>
    </BrowserRouter>
  );
}
